<template>
  <div
    class="block-wrap block-specification"
    style="padding:10px">
    <div
      v-for="(s, sindex) in specifications"
      :key="s.nameKey">
      <div class="title-bg">
        规格名：
        <template>
          <el-input :disabled="s.disabledSpName" style="width:140px" v-model="s.name" :maxlength="20" @keyup.enter.native="(e) => nameEnter(sindex)" @change="e => nameChange(s)"></el-input>
          <el-checkbox
            style="margin-left: 8px"
            v-model="s.checked"
            @change="e => onChangeSpCheckbox(s)"
            :disabled="s.disabled || (s.checked && specifications.filter(item => item.checked).length === 1)"></el-checkbox>
          <el-button
            v-if="remarkKey"
            style="float: right; margin-right: 8px"
            type="link"
            @click="openBatchRemarkDialog(s.name)">批量设置规格备注</el-button>
        </template>
        <el-button
          style="float: right"
          v-show="showDelSpNameBtn" type="link" @click="removeSpName(sindex)">删除</el-button>
      </div>
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left:10px;">规格值：</div>
        <vue-draggable class="specification-value-flex" v-model="specifications[sindex].values" handle=".drag-icon-wrap" :group="{ name: s.nameKey, pull: 'clone', put: false }" :animation="500">
          <div
            v-for="(v, vi) in specifications[sindex].values"
            :key="v.valueKey"
            class="specification-value-flex_item">
            <div class="del-input-wrap">
              <el-select
                v-if="s.formType == 'select'"
                :ref="`${sindex}-${vi}`"
                :class="{'is-error': v.valueErrorMsg}"
                allow-create
                blur-create
                filterable
                @change="(value) => selectedHandle(sindex, vi, value, v, s)" 
                class="specification-value-flex_input"
                v-model="v.value">
                <el-option
                  v-for="op in s.options"
                  :key="op.value"
                  :label="op.displayName"
                  :value="op.displayName"
                  :disabled="s.values.some(_v => _v.value === op.displayName)"></el-option>
              </el-select>
              <template v-else-if="s.formType == 'taoSirProperty'">
                <InputTaoSir :_value="v.value" :propertie="s.properties[0]" @change="(formats) => inputTaoSirchange(sindex, vi, formats)"></InputTaoSir>
              </template>
              <el-input
                v-else
                :ref="`${sindex}-${vi}`"
                @blur="(e) => blurHandle(sindex, vi, e)" class="specification-value-flex_input"
                @keyup.enter.native="(e) => valueEnter(sindex, vi)"
                @input="(e) => valueInput(v)"
                v-model="v.value"></el-input>
              <div @click="removeSpValue(sindex, vi, v)" class="del-btn"><i class="el-icon-close" /></div>
              <el-checkbox
                style="margin-left: 8px"
                v-model="v.checked"
                @change="e => onChangeCheckbox(v)"
                :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"></el-checkbox>
              <drag-item-content></drag-item-content>
              <div v-if="v.valueErrorMsg" style="height: 20px;"><span class="el-form-item__error" style="top: 25px;"> {{ v.valueErrorMsg }}</span> </div>
            </div>
            <div v-if="remarkKey" class="remarkWrap">
              <el-input
                class="input-remark"
                :ref="`${sindex}-${vi}-remark`"
                placeholder="规格备注"
                @input="e => remarkInput(v)"
                v-model="v[remarkKey]"></el-input>
            </div>
            <div v-if="sindex === 0 && !noSpPic" class="specification-value-flex_img">
              <ImgUpload
                ref="imgs"
                :width="80"
                :height="80"
                :size="150"
                :file="v.imageUrl"
                @upload-success="(url) => imageUploadSuccess(url, v)"
                @del="() => imageUploadDel(v)"
                :limitSuffix="imgLimitSuffix"
                :showAuditResult="showAuditResult"
                :auditFileList="auditFileList"
                :isSingle="true"
                :upload_err="true"
                :autoCropImageParams="{targetWidth:800,targetHeight:800}"
                v-bind="imgAttr"
              />
              <div class="el-form-item__error" v-if="imgErrMsgs[vi+'']" style="width:120px; margin-left:0px !important">{{ imgErrMsgs[vi+''] }}</div>
            </div>
          </div>
          <div class="specification-value-flex_item drag-ignore_item">
            <el-button @click="addSpValue(sindex)" type="link">添加规格值</el-button>
          </div>
        </vue-draggable>
      </div>
    </div>
    <BatchSetSpecRemarksDialog ref="batchSetSpecRemarksDialogRef"/>
  </div>
</template>

<script>
import FormItemSpecification from "@/components/prod/center/components/FormItemSpecification/FormItemSpecification.vue"
import InputTaoSir from '../../Input/InputTaoSir.vue';
import BatchSetSpecRemarksDialog from '@/components/prod/center/components/BaseInfoForm/components/BatchSetSpecRemarksDialog.vue';

import { dragItemMixin } from '@/components/prod/center/utils/mixins'

export default {
  extends: FormItemSpecification,
  props: ['imgAttr'],
  mixins: [dragItemMixin],
  components: {
    InputTaoSir,
    BatchSetSpecRemarksDialog
  },
  data() {
    return {
      imgErrMsgs: {},
    }
  },
  methods: {
    openBatchRemarkDialog(name) {
      this.$refs.batchSetSpecRemarksDialogRef.method_open({
        name,
        remarkKey: this.remarkKey,
        specifications: this.specifications,
        sureFn: (specs) => {
          this.$emit('change', JSON.parse(JSON.stringify(specs)));
        },
      });
    },
    // select类型选择
    selectedHandle(sindex, vi, value, v, s) {
      this.$set(v, 'isEdited', true)
      this.blurHandle(sindex, vi, {target: {value}}, {formType: 'select'})
      this.checkOneValueError(v, s)
    },
    // 规格值输入
    blurHandle(sindex, vi, e, {formType} = {}) {
      const _value = e.target.value
      if (!_value) return this.$message.error('请填写规格值')
      const values = this.specifications[sindex].values
      let isSame = false
      values.forEach((item, i) => {
        if (vi !== i && item.value === _value) {
          isSame = true
        }
      })
      if (isSame) { 
        this.$message.error(`请勿${formType == 'select' ? '选择' : '输入'}相同规格值`)
      }
    },
    inputTaoSirchange(sindex, vi, formats) {
        this.$set(v, 'isEdited', true)
        const concatTypes = ['input', 'operator', 'unit'];
        const isEveryValue = formats.every(item => item.text)
        let value = '';
        // 度量衡组合完整才更新
        if(isEveryValue) {
          value = formats.filter(item => concatTypes.includes(item.type)).map(item => item.text).join('');
          this.specifications[sindex].values[vi].value = value;
          this.blurHandle(sindex, vi, { target: { value } });
        }
    },

  },
  watch: {
   
  },
}
</script>
